import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { CrowdFlowAlertsStore, CrowdFlowAlertsState } from './crowd-flow-alerts.store';

@Injectable({ providedIn: 'root' })
export class CrowdFlowAlertsQuery extends QueryEntity<CrowdFlowAlertsState> {

  constructor(protected store: CrowdFlowAlertsStore) {
    super(store);
  }

  selectAlertsForROI(roiID: string) {
    return this.selectAll({
      filterBy: crowdFlowAlert => crowdFlowAlert.crowdFlowRoiId === roiID
    });
  }
}
